import { InfoCircleOutlined } from '@ant-design/icons'
import { MomentDatePicker } from '@gravitate-js/excalibrr'
import { Alert, Button, Select } from 'antd'
import React from 'react'
import { useWizardMaster } from '../../../../../Contexts/WizardMasterContext'
import { useUnmonitoredWindow } from './useUnmonitoredWindow'
const { Option } = Select
const { RangePicker } = MomentDatePicker

export const predefinedWindowOptions = [
  { value: JSON.stringify([0, 6]), label: '12:00AM - 6:00AM', startHour: 0, endHour: 6 },
  { value: JSON.stringify([6, 12]), label: '6:00AM - 12:00PM', startHour: 6, endHour: 12 },
  { value: JSON.stringify([12, 18]), label: '12:00PM - 6:00PM', startHour: 12, endHour: 18 },
  { value: JSON.stringify([18, 0]), label: '6:00PM - 12:00AM', startHour: 18, endHour: 0 },
  { value: JSON.stringify([6, 18]), label: '6:00AM - 6:00PM', startHour: 6, endHour: 18 },
  { value: JSON.stringify([18, 6]), label: '6:00PM - 6:00AM', startHour: 18, endHour: 6 },
  { value: JSON.stringify([0, 12]), label: '12:00AM - 12:00PM', startHour: 0, endHour: 12 },
  { value: JSON.stringify([12, 0]), label: '12:00PM - 12:00AM', startHour: 12, endHour: 0 },
]

export const UnmonitoredDeliveryWindow = () => {
  const { setPayload, wizardOrder, setMode } = useWizardMaster()
  const {
    isSettingCustom,
    selectedDate,
    setSelectedDate,
    selectedTimeWindow,
    setSelectedTimeWindow,
    setIsSettingCustom,
    customDeliveryDate,
    handleTimeChange,
  } = useUnmonitoredWindow(wizardOrder, setPayload, setMode)

  return (
    <div>
      <Alert
        className='edited-order info'
        message={
          <div className='flex justify-sb'>
            <SelectMessage />
            {isSettingCustom ? (
              <CustomWindowSelect
                customDeliveryDate={customDeliveryDate}
                handleTimeChange={handleTimeChange}
                setIsSettingCustom={setIsSettingCustom}
                setSelectedTimeWindow={setSelectedTimeWindow}
              />
            ) : (
              <PredefinedWindowSelect
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                selectedTimeWindow={selectedTimeWindow}
                setSelectedTimeWindow={setSelectedTimeWindow}
                setIsSettingCustom={setIsSettingCustom}
              />
            )}
          </div>
        }
      />
    </div>
  )
}
const SelectMessage = () => {
  return (
    <div>
      <span className='alert-align'>
        <InfoCircleOutlined className='alert-icon-large' />
      </span>
      <span className='alert-align' style={{ paddingLeft: '1em' }}>
        You have selected an unmonitored tank, please select a delivery window to save the order.
      </span>
    </div>
  )
}
const PredefinedWindowSelect = ({
  selectedDate,
  setSelectedDate,
  selectedTimeWindow,
  setSelectedTimeWindow,
  setIsSettingCustom,
}) => {
  return (
    <div>
      <MomentDatePicker value={selectedDate} onChange={setSelectedDate} className='mr-3' />
      <Select
        value={selectedTimeWindow}
        onChange={setSelectedTimeWindow}
        style={{ width: 175 }}
        placeholder='Select Window'
      >
        <Select.OptGroup label='6 Hour Windows'>
          {predefinedWindowOptions.slice(0, 4).map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select.OptGroup>
        <Select.OptGroup label='12 Hour Windows'>
          {predefinedWindowOptions.slice(4).map((option) => (
            <Option key={option.value} value={option.value}>
              {option.label}
            </Option>
          ))}
        </Select.OptGroup>
      </Select>
      <Button
        onClick={() => setIsSettingCustom(true)}
        icon={<InfoCircleOutlined className='pr-2' />}
        style={{ color: 'white' }}
        type='link'
      >
        <i>Set Custom Window</i>
      </Button>
    </div>
  )
}
const CustomWindowSelect = ({ customDeliveryDate, handleTimeChange, setIsSettingCustom, setSelectedTimeWindow }) => {
  const blurEndInput = () => {
    // Safe way to access the picker DOM element

    const pickerElement = document.querySelector('.ant-picker-range')
    const endInput = pickerElement?.querySelectorAll('.ant-picker-input')?.[1]
    if (endInput instanceof HTMLElement) {
      endInput.blur()
    }
  }
  return (
    <div className='justify-end flex'>
      <RangePicker
        format='YYYY-MM-DD h:mmA'
        onCalendarChange={(dates) => {
          handleTimeChange(dates)
          blurEndInput()
        }}
        showTime={{ format: 'h:mmA' }}
        defaultValue={customDeliveryDate}
        onChange={handleTimeChange}
      />
      <Button
        icon={<InfoCircleOutlined className='pr-2' />}
        onClick={() => {
          setIsSettingCustom(false)
          setSelectedTimeWindow(predefinedWindowOptions[0].value)
        }}
        style={{ color: 'white' }}
        type='link'
      >
        Set Pre-defined Window
      </Button>
    </div>
  )
}
